export default function ClosedEventStamp({ active, children, className = "" }) {
  return (
    <div className={`relative ${className}`}>
      {children}
      {active && (
        <div className="absolute inset-0 z-10 flex items-center justify-center pointer-events-none" data-testid="closed-event-stamp">
          <div className="-rotate-12 rounded-xl border-4 border-slate-400/90 bg-blue-50/85 px-6 py-3 shadow-xl backdrop-blur-[2px]">
            <p className="text-center text-xl sm:text-2xl font-black uppercase tracking-widest text-slate-500">Événement complet</p>
            <p className="text-center text-xs sm:text-sm font-bold uppercase tracking-widest text-blue-500 mt-0.5">Inscription clôturée</p>
          </div>
        </div>
      )}
    </div>
  );
}
